import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=05a4185e&scoped=true"
import script from "./infoDialog.vue?vue&type=script&lang=js"
export * from "./infoDialog.vue?vue&type=script&lang=js"
import style0 from "./infoDialog.vue?vue&type=style&index=0&id=05a4185e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a4185e",
  null
  
)

export default component.exports